/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_SelectInputs */

const zh_common_select = /** @type {(inputs: Common_SelectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择`)
};

const en_common_select = /** @type {(inputs: Common_SelectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select`)
};

const es_common_select = /** @type {(inputs: Common_SelectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccionar`)
};

/**
* | output |
* | --- |
* | "Select" |
*
* @param {Common_SelectInputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_select = /** @type {((inputs?: Common_SelectInputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_SelectInputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_common_select(inputs)
	if (locale === "en") return en_common_select(inputs)
	return es_common_select(inputs)
});